import { Menu, Transition } from '@headlessui/react'
import { useDispatch, useSelector } from 'react-redux'
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom'
import React, { Fragment, useState } from 'react'
import { Tooltip } from 'flowbite-react';
import { LoginIcon, ProfileIcon } from '../../../theme/icons';
import { LOGOUT } from '../../../grapghQl/queries/auth';
import { useToasts } from '../../Toast';
import { Skeleton } from '../Skeleton';
import { actionLogout } from '../../../redux/actions/auth';
import { CustomModalRoot } from '../Modal/CustomModalroot';
import { LogoutConfrimation } from './LogoutConfrimation';
import { useGAEvent } from '../ReactGA';
import { customEvents } from '../../../utils/customEvents'
import { Avatar } from '..'; 
import { generateBGColorClassName } from '../../../utils/randomColor';

export default function ProfileMenu(props) {
    const { intl: { messages }, userName } = props;
    const dispatch = useDispatch()
    const sendGAEvent = useGAEvent();
    const [Logout, { loading: logoutLoader }] = useMutation(LOGOUT);
    const { setToastMessage } = useToasts();
    const navigate = useNavigate();
    const { user } = useSelector(state => state?.auth);
    const { authToken, first_name, last_name } = user;

    const [isOpenDialogue, setDialogue] = useState({ isOpen: false })

    const onCloseDialogue = () => setDialogue({ isOpen: false })

    const handleLogout = async (e) => {
        e.preventDefault();
        try {
            const { data } = await Logout({ variables: { authToken } })
            if (data) {
                setToastMessage({ message: messages?.['LOGOUT.SUCCESS.MESSAGE'], variant: 'success' })
                sendGAEvent(customEvents.GA_LOGOUT)
                dispatch(actionLogout())
                onCloseDialogue();
                localStorage.removeItem('token');
                localStorage.removeItem('super-admin-auth');

                window.location.pathname = '/login';
            }
        } catch (error) {
            setToastMessage({ message: error?.message, variant: "error" });
            onCloseDialogue();
        }
    }

    const handleProfileClick = () => {
        sendGAEvent(customEvents.GA_PROFILE)
        navigate('/profile');
    }

    const handleOpenModal = () => setDialogue({
        ...isOpenDialogue,
        isOpen: true,
        loader: logoutLoader,
        content: {
            title: messages?.['LOGOUT.CONFIRM.MESSAGE.TITLE'],
            description: messages?.['LOGOUT.CONFIRM.MESSAGE.DESCRIPTION'],
            handleYes: (e) => handleLogout(e),
            yesButtonLabel: 'Yes, Logout',
            noButtonLabel: 'No, Cancel',
            loader: logoutLoader,
            loaderYestext: "Logging out...",
            onCloseDialog: () => onCloseDialogue()
        }
    })

    const onLogout = () => handleOpenModal();

    const profileOptions = [
        {
            id: 0,
            title: 'Profile',
            icon: <ProfileIcon
                className="m-0 h-5 w-5"
                aria-hidden="true"
            />,
            onClick: () => handleProfileClick()
        },
        {
            id: 1,
            title: 'Logout',
            icon: <LoginIcon
                className="m-0 h-5 w-5 "
                aria-hidden="true"
            />,
            onClick: () => onLogout()
        },
    ]

    return (
        <div className="h-10 w-10">
            <CustomModalRoot isOpenDialogue={{
                ...isOpenDialogue,
                children: <LogoutConfrimation loader={logoutLoader} content={isOpenDialogue?.content} />
            }} />
            <Menu as="div" className="relative inline-block text-left">
                <div className="h-10 w-10">
                    {logoutLoader ? <Skeleton className={"h-10 w-10 max-w-350 m-auto rounded-full"} length={1} /> :
                        <Menu.Button className="inline-flex w-full justify-center rounded-md">
                            <Tooltip placement="bottom" content="Profile Menu">
                                <div className="flex-shrink-0 w-10 h-10 m-0 p-0">
                                    <Avatar type="text"  alt={userName || `${first_name} ${last_name}`} className={`${generateBGColorClassName(5)} !h-10 !w-10`}/>
                                </div>
                            </Tooltip>
                        </Menu.Button>}
                </div>
                <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95">
                    <Menu.Items className="absolute z-10 right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <div className="px-1 py-1 ">
                            {!!profileOptions?.length &&
                                profileOptions?.map(option =>
                                    <Menu.Item key={option.title}>
                                        <button
                                            onClick={option?.onClick}
                                            className={`text-gray-900 group flex w-full items-center rounded-md px-2 py-2 text-sm`}>
                                            <span className='mx-1.5 w-7'>
                                                {option.icon}
                                            </span>
                                            {option?.title}
                                        </button>
                                    </Menu.Item>)}
                        </div>
                    </Menu.Items>
                </Transition>
            </Menu>
        </div>
    )
}

